import { flatten, keyBy } from 'lodash';
import { REPORT_ORDER } from '../modules/campaigns-reports/config/reports/reportsOrder';

const reportMap = keyBy(flatten(REPORT_ORDER.map(item => item?.options || item)));

export const isStaticReport = reportId => !!reportMap[reportId];

export const isDynamicReport = reportId => !!reportId && !isStaticReport(reportId);
